import productAPI from '@/module/product/api/product';
import checkoutLinkAPI from '@/module/product/api/checkoutLink';

export default function product(instance) {
  return {
    product: productAPI(instance),
    checkoutLink: checkoutLinkAPI(instance),
  };
}
